import { Controller } from "@hotwired/stimulus"

// Adds a soft fade under a sticky header only once the page has actually
// scrolled, so content at rest isn't washed out by the gradient.
//
// Usage: data-controller="sticky-fade" on the sticky header element.
export default class extends Controller {
  connect() {
    this.onScroll = () => {
      this.element.classList.toggle("section-header-fade", window.scrollY > 8)
    }
    this.onScroll()
    window.addEventListener("scroll", this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    this.element.classList.remove("section-header-fade")
  }
}
